module.exports = __webpack_public_path__ + "static/desktop/img/case5.5102b71c.png";